// Runtime config: window.__ENV__ (Docker) takes priority over process.env (dev)
const getEnv = (key) => {
  const runtimeVal = window.__ENV__?.[key];
  if (runtimeVal) return runtimeVal;
  return process.env[key] || null;
};

export const API_BASE_URL = (() => {
  const url = getEnv("REACT_APP_API_URL");
  if (url) return url.includes("/api/v1") ? url : `${url}/api/v1`;
  return "http://localhost:8000/api/v1";
})();

export const CHATWOOT_URL = getEnv("REACT_APP_CHATWOOT_URL");
export const WEBSITE_TOKEN = getEnv("REACT_APP_WEBSITE_TOKEN");
